import React, { useEffect, useState } from 'react';
//Header Data

//Footer Data

//Styles
import styles from './../Profile.module.scss';
import { PaginationSwitch, ContestPortfolioNavigation } from '../../../components/Profile/PortfolioNavigation/PortfolioNavigation';
import { GalleryDesign, User } from '../../../global';

import DesignCard from '../../../components/Design/DesignCard/DesignCard';
import DesignRow from '../../../components/Design/DesignCard/DesignRow';

import axiosHelper from '../../../helpers/axiosHelper';
import useSWR from 'swr';
import { setPortfolioNames } from '../../../store/DesallStore';

interface Props {
  user: User;
  loggedUser: User | null;
  breadcrumbs: (breadcrumbs: string) => void;
}

const PortfolioWLF: React.FC<Props> = ({ user, loggedUser, breadcrumbs }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [layoutPortfolio, setLayoutPortfolio] = useState(1);

  const [visibleDesigns, setVisibleDesigns] = useState<GalleryDesign[]>([]);
  const { data, error, isLoading } = useSWR('uid|' + user.id, axiosHelper.portfolioFetcher);

  useEffect(() => {
    console.log('DATA', data);
    if (data) {
      let names = [];
      for (let i = 0; i < data.length; i++) {
        names.push(data[i].nameForURL);
      }
      setPortfolioNames(names);
      setVisibleDesigns(data);
    } else {
      setVisibleDesigns([]);
    }
  }, [data]);

  useEffect(() => {
    breadcrumbs('Portfolio');

  }, [user, breadcrumbs]);

  return (
    <div className="bg-light-gray">
      <main className={`${styles.profileWrapper} container pt-5  mb-5 px-sm-0    `}>
        <div className={` row `}>
          <ContestPortfolioNavigation onChangeLayout={setLayoutPortfolio} />
        </div>
        <div className="row me-2 ">
          <div className={`row mt-2  px-md-4 px-lg-2 ps-lg-2`} style={{ minHeight: '100px' }}>
            {layoutPortfolio === 1
              ? visibleDesigns.map((aDesign: GalleryDesign, index: number) => (
                  <div key={index} className=" col-12 col-md-6 col-lg-4 col-xl-3">
                    <DesignCard design={aDesign} user={user} />
                  </div>
                ))
              : visibleDesigns.map((aDesign: GalleryDesign, index: number) => (
                  <>
                    <DesignRow key={index} design={aDesign} />
                  </>
                ))}
          </div>
        </div>
        <div className="row ">
          <div className="col-12  d-flex justify-content-sm-start justify-content-md-end">{visibleDesigns.length > 0 ? <PaginationSwitch onChangePage={setPageNumber} /> : ''}</div>
        </div>
      </main>
    </div>
  );
};

export default PortfolioWLF;
